import styled from 'styled-components'
// themes
import { colors } from 'themes/index'

export const Wrapper = styled('div')`
  display: flex;
  flex-direction: column;
`

export const Row = styled('div')`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 8px;

  > div:first-child {
    flex: 1;
  }
`

export const RemoveButton = styled('div')`
  align-items: center;
  cursor: pointer;
  display: flex;
  height: 40px;

  svg {
    width: 20px;
    height: 20px;
  }

  &:hover svg {
    fill: ${colors.red500};
  }
`

export const Label = styled('div')`
  display: flex;
  color: ${colors.gray300};
  font-size: 13px;
`
